import { MORE_768_MEDIA_QUERY } from '../../../../../consts/adaptive';

export const styles = {
  roomInfoContent: {
    display: 'flex',
    flexFlow: 'column nowrap',
    boxSizing: 'border-box',
    margin: '0 0.625rem',

    '& *': {
      boxSizing: 'border-box',
    }
  },

  infoRow: {
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'space-between',
    marginBottom: '1rem',
  },

  [MORE_768_MEDIA_QUERY]: {
    roomInfoContent: {
      margin: 0,
    },

    infoRow: {
      flexFlow: 'row nowrap',
    },
  }
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
